
import { Component, Prop, Vue } from 'vue-property-decorator';
import { PlanInterface } from '@/services/Plan/interfaces';

@Component
export default class DeletePlanDialog extends Vue {
  @Prop() public plan!: PlanInterface;

  public visible: boolean = true;

  get message(): string {
    return `Are you sure you want to delete plan ${this.plan.name}?`;
  }

  public destroyComponent(): void {
    this.$emit('close');
    this.visible = false;
  }

  public async deletePlan(): Promise<void> {
    this.$emit('deletePlan', this.plan.id);
    this.destroyComponent();
  }
}
